window.Vue = require('vue');

import MapComponent from "./components/MapComponent"

window.app = new Vue({
  el: '#app',
  data:{
  },
  components: {
    'map-component': MapComponent
  },
  watch: {

  },
  computed: {

  },
  methods: {
  },
  mounted() {



  }

});
